import { gql } from '@efficiently/client-core-graphql-models';

export const CHECK_DELETE_FINISHES = gql(`
	mutation FinishDomainCheckDeleteFinishes($ids: [String!]!) {
		checkDeleteFinishes(ids: $ids) {
			plansItems {
				name
				url
			}
			booksItems {
				name
				url
			}
			hasReferences
			typeText
		}
	}
`);

export const DELETE_FINISHES = gql(`
	mutation FinishDomainDeleteFinishes($ids: [String!]!) {
		deleteFinishes(ids: $ids)
	}
`);

export const DELETE_FINISHES_WITH_CASCADE = gql(`
	mutation FinishDomainDeleteFinishesWithCascade($ids: [String!]!) {
		deleteFinishesWithCascade(ids: $ids) {
			deletedIds
			cascade {
				finishIds {
					_id
					status
				}
				finishes {
					_id
					status
				}
			}
		}
	}
`);
